import { ga } from 'js/analytics/adapters'
import { setItem } from 'js/storeManager'

export const setEntryPoint = (entryPoint, coupon?) => {
  ga.user('EntryPoint', entryPoint)
  ga.user('Coupon', coupon)
  setItem('EntryPoint', JSON.stringify({ entryPoint, coupon }))
}
